import ReactApexChart from "react-apexcharts";

type Props = {
  graphData: any;
};

export const PieChart: any = ({ graphData }: Props) => {
  const series: any = [44, 15, 41, 57];
  let sum = series.reduce(function (a: any, b: any) {
    return a + b;
  }, 0);

  const options: any = {
    chart: {
      width: 200,
      type: "donut",
      dropShadow: {
        enabled: true,
        color: "#111",
        top: -1,
        left: 3,
        blur: 3,
        opacity: 0.5,
      },
    },
    stroke: {
      width: 0,
    },

    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            "": {
              showAlways: true,
              show: false,
            },

            value: {
              offsetY: -7,
              formatter: function (val: string) {
                return ((+val * 100) / sum).toFixed(1).toString() + "%";
              },
            },
          },
        },
      },
    },
    labels: [
      "ООО Ессентуки минеральные воды ",
      "ООО Святой источник ",
      "ООО Архыз",
      "The Coca-Cola Company",
    ],
    dataLabels: {
      enabled: false,
      dropShadow: {
        blur: 0,
        opacity: 0,
      },
    },

    states: {
      hover: {
        filter: "none",
      },
    },
    theme: {
      palette: "palette3",
    },

    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
        },
      },
    ],
    legend: false,
    /*legend: {
      position: "bottom",
    },*/
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="donut"
      width={200}
    />
  );
};
